import React, { type ComponentType } from 'react';
import { getComponent } from 'Cms/descriptors';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Tabs } from 'Components/frameworks/tabs/Tabs';
import { asLegacyJsxComponent, castAs } from 'Src/types/cast-helpers';
type TabLineProps = {
  anchor: string;
  color: string;
  header: {
    icon: string;
    title: string;
  };
  isExpanded?: boolean;
};
type Props = {
  id?: string;
  lines: Array<{
    props: TabLineProps;
    name: string;
  }>;
};
export const TabsLine = ({ id, ...props }: Props) => {
  const { isTablet } = useResponsive();
  const items = props.lines.map((line) => {
    const TabContent = asLegacyJsxComponent(
      castAs<ComponentType<unknown>>(getComponent(line.name)),
    );
    return {
      content: [<TabContent {...line.props} key="1" />],
      header: {
        color: line.props.color,
        iconName: line.props.header.icon,
        title: line.props.header.title,
      },
      id: line.props.anchor || null,
    };
  });
  const initialSelectedItems = props.lines
    .map((line, index) => {
      return line.props.isExpanded ? index : -1;
    })
    .filter((i) => i > -1);
  return (
    <SiteContainer className="Line" id={id}>
      <Tabs
        initialSelectedItems={isTablet ? [0] : initialSelectedItems}
        hasControlsOnTouch
        isContainerWide
        isScrollable
        items={items}
      />
    </SiteContainer>
  );
};
